import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { Body1, Headline2 } from 'stories/elements/Typography/Text'
import CollabsibleAccordion from 'components/modules/Accordion/CollapsibleAccordion'
import FAQSchemaData from 'components/modules/SEO/FAQSchemaData'
import _useTranslation from 'lib/hooks/_useTranslation'
import { useRouter } from 'next/router'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background-color: ${theme.colors.businessBlue};
    display: grid;
    overflow: hidden;
    @media (max-width: 750px) {
        min-height: 800px;
        min-height: auto;
        h2 {
            padding-left: 35px;
        }
    }
`

interface Props {
    isMobile?: boolean
}
const FAQComponent = ({ isMobile }: Props) => {
    const router = useRouter()
    const { locale } = router
    const { t } = _useTranslation('homepage')
    const countryLanguageConfig = getCountryLanguageConfig(locale)
    const isLaunched = countryLanguageConfig?.isLaunched

    const textsData = [
        {
            question: t('homepage/aiCompanionFaqTitle'),
            answer: t('homepage/aiCompanionFaqSubtitle'),
        },
        {
            question: t('homepage/faqTitle1'),
            answer: t('homepage/faqSubtitle1'),
        },
        {
            question: t('homepage/faqTitle2'),
            answer: t('homepage/faqSubtitle2'),
        },
        {
            question: t('homepage/faqTitle3'),
            answer: t('homepage/faqSubtitle3'),
        },
    ]

    const FAQData = textsData.map(({ question, answer }) => ({
        title: question,
        text: <Body1 color={isMobile ? theme.colors.subtitleBlack : theme.colors.accentBlue}>{answer}</Body1>,
    }))

    return (
        <Container>
            <section>
                {/* Adding mobile condition so data won't be added twice to DOM */}
                {isMobile && isLaunched && <FAQSchemaData faqItems={textsData} />}
                <Headline2 color={theme.colors.white} textAlign={isMobile ? 'left' : 'center'} marginBottom={50}>
                    {t('homepage/faqSectionHeader')}
                </Headline2>
                {FAQData.map((data, i) => (
                    <CollabsibleAccordion
                        key={`faq-question-${i}`}
                        text={data.text}
                        title={data.title}
                        openByDefault={i === 0}
                    />
                ))}
            </section>
        </Container>
    )
}

export default FAQComponent
